var React = require('react');

function BarChartUp60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M57.784 59.88h-8.88c-.55 0-.904-.449-.904-1V20.879c0-.551.354-.991.904-.991h8.88c.55 0 1.216.44 1.216.991V58.88c0 .551-.666 1-1.216 1zm-.784-38h-7v36h7v-36zm1.775-16.534l-3.997 9.073a.995.995 0 0 1-1.313.51 1.002 1.002 0 0 1-.507-1.32l3.008-6.83-54.463 23.03a.997.997 0 0 1-1.304-.535 1.002 1.002 0 0 1 .532-1.31L55.28 4.9l-6.773-2.966a1.002 1.002 0 0 1-.516-1.316.994.994 0 0 1 1.311-.517l8.736 3.825a.979.979 0 0 1 .744.578.996.996 0 0 1 .072.424.99.99 0 0 1-.079.418zM1.117 37.884h9.042c.55 0 .841.444.841.995V58.88c0 .551-.291 1-.841 1H1.117c-.55 0-1.117-.449-1.117-1V38.879c0-.551.567-.995 1.117-.995zM2 57.88h7v-18H2v18zm15.128-25.994h8.878c.55 0 .996.447.996.999v25.996a.998.998 0 0 1-.996.999h-8.878c-.55 0-1.128-.449-1.128-1v-26c0-.552.578-.994 1.128-.994zM18 57.88h7.011V33.886L18 33.88v24zm14.975-31.993h8.88c.55 0 1.145.44 1.145.992V58.88c0 .551-.595 1-1.145 1h-8.88a.997.997 0 0 1-.995-.999V26.887c0-.552.445-1 .995-1zm.996 31.993H41v-30l-7.029.006V57.88z","key":1})]);
}

BarChartUp60px.displayName = "BarChartUp60px";

BarChartUp60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59 59.88"};

module.exports = BarChartUp60px;

BarChartUp60px.default = BarChartUp60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/bar-chart-up-60px.svg
// module id = 1181
// module chunks = 0